import {
  IntlProvider,
  LocalizationProvider,
  load,
  loadMessages,
} from "@progress/kendo-react-intl";
import currencyData from "cldr-core/supplemental/currencyData.json";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import weekData from "cldr-core/supplemental/weekData.json";
import caGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/fr/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/fr/timeZoneNames.json";
import currencies from "cldr-numbers-full/main/fr/currencies.json";
import numbers from "cldr-numbers-full/main/fr/numbers.json";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import ContainerContent from "./commons/container/ContainerContent";
import frMessages from "./configs/fr-CA.json";
import { TOKEN, USER } from "./constants/localStorage";
import MenuHeader from "./header/MenuHeader";
import MainLayout from "./pages/MainLayout";
import NotFound from "./pages/NotFound";
import Account from "./pages/account/Account";
import Connection from "./pages/connection/Connection";
import { useLazyLoginWithTokenQuery } from "./redux/api/login";
import { setToken, setUser } from "./redux/slices/appStateSlice";

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
);
loadMessages(frMessages, "fr-CA");

function App() {
  const [loginWithToken] = useLazyLoginWithTokenQuery();
  const dispatch = useDispatch();
  const [urlLoaded, setUrlLoaded] = useState(false);

  useEffect(() => {
    let getUrlInfos = async () => {
      var search = new URLSearchParams(window.location.href.split("?")[1]);

      if (search.get("applicatauthtoken") !== null) {
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(USER);
        let token = search.get("applicatauthtoken");
        let result = await loginWithToken(token).unwrap();
        let authorizationToken = result.headers.get("Authorization");
        localStorage.setItem(TOKEN, authorizationToken ?? "");
        localStorage.setItem(USER, (result.body as any).usager);
        dispatch(setToken(authorizationToken ?? ""));
        dispatch(setUser((result.body as any).usager));
        window.history.replaceState({}, "", window.location.href.split("?")[0]);
      } else if (search.get("token") !== null && search.get("user") !== null) {
        let token = search.get("token");
        localStorage.setItem("token", `Bearer ${search.get("token")}`);
        localStorage.setItem("user", `${search.get("user")}`);
        dispatch(setToken(`Bearer ${token}`));
        dispatch(setUser(search.get("user")!));
        window.history.replaceState({}, "", window.location.href.split("?")[0]);
      }
    };
    getUrlInfos();
    setUrlLoaded(true);
  }, [dispatch, loginWithToken]);

  return urlLoaded ? (
    <LocalizationProvider language="fr-CA">
      <IntlProvider locale="fr">
        <Connection>
          <ContainerContent>
            <BrowserRouter>
              <div className="k-d-flex k-flex-column k-grid-cols-1 k-h-screen k-max-h-screen">
                <MenuHeader />
                <Routes>
                  <Route path="/" element={<MainLayout />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </BrowserRouter>
          </ContainerContent>
        </Connection>
      </IntlProvider>
    </LocalizationProvider>
  ) : (
    <></>
  );
}

export default App;
